import axios from './upstreamAwareAxios';
import { getAuth } from '../providers/AppAuthProvider';
import { Resources } from '../resources/resource';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = Resources.agents;

export const findAgentAPI = async (id: number): Promise<any>  =>{
  const url = `${baseUrl}/${resource}/${encodeURIComponent(id)}`;

  const { accessToken } = (await getAuth()) || {};

  const res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
    },
    validateStatus: (s) => s >= 200 && s < 300,
  });

  return res.data?.data ?? res.data;
}
